import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { SaveDataService } from '@app/shared/services/save-data.service';
import { AddressDataService } from '@app/shared/services/common-data/address-data.service';

import { DropdownChangeEvent } from 'primeng/dropdown';
import { StreetType } from '@app/shared/interfaces/common-data/street-type';
import { Province } from '@app/shared/interfaces/common-data/province';
import { PostalCode } from '@app/shared/interfaces/common-data/postal-code';
import { CoreModule } from '@app/core/core.module';
import { AppService } from '@app/app.service';

@Component({
    selector: 'app-house-address',
    standalone: true,
    imports: [CoreModule, CommonModule, SharedModule, TranslateModule],
    templateUrl: './house-address.component.html',
    styleUrl: './house-address.component.scss',
})
export class HouseAddressComponent {

	private appData = inject(AppService);

    continueButton = 'common.buttons.continueButton';
    backButton = 'common.buttons.backButton';

    houseAddressTitle = 'features.housing.houseAddress.houseAddressTitle';
    houseAddressSubtitle = 'features.housing.houseAddress.houseAddressSubtitle';

    streetTypeFloatLabel = 'features.housing.houseAddress.streetTypeFloatLabel';
    streetNameLabel = 'features.housing.houseAddress.streetNameLabel';

    streetNumberLabel = 'features.housing.houseAddress.streetNumberLabel';
    streetAdditionalInfoLabel = 'features.housing.houseAddress.streetAdditionalInfoLabel';
    infoStreetAdditionalInfo = 'features.housing.houseAddress.infoStreetAdditionalInfo';


    cityFloatLabel = 'features.housing.houseAddress.cityFloatLabel';
    postalCodeLabel = 'features.housing.houseAddress.postalCodeLabel';

    provinceFloatLabel = 'features.housing.houseAddress.provinceFloatLabel';

    backButtonDisabled = false;
    continueButtonDisabled = true;

    isPortraitDevice = false;

    formGroup!: FormGroup;

    streetTypes: StreetType[] = [];
    selectedStreetType!: StreetType | undefined;

    provinces: Province[] = [];
    selectedProvince!: Province | undefined;

    cities: string[] = ["Almeria"];
    selectedCity?: string;

    postalCodes: PostalCode[] = [];
    selectedPostalCode!: PostalCode;
    suggestionsCity: string[] = [];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private saveDataService: SaveDataService,
        private changeStepService: ChangeStepService,
        private addressDataService: AddressDataService,
        private fb: FormBuilder
    ) {
        this.changeStepService.changeStep(6);
    }
    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });

        this.createForm();
        this.initDefaultValues();
        this.setValuesForm(this.appData.data.userData.houseAddress);

        this.formIsValid();
    }

    createForm() {
        //this.initDefaultValues();

        this.formGroup = this.fb.group({
            //-CONT
            streetType: new FormControl(this.selectedStreetType ? this.selectedStreetType.code : '', [Validators.required, Validators.nullValidator]),
            streetName: new FormControl('', [Validators.required]),
            streetNumber: new FormControl('', [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(5),
                Validators.pattern(/^-?(0|[1-9]\d*)?$/),
            ]),
            streetAdditionalInfo: new FormControl(''),
            city: new FormControl(this.selectedCity ? this.selectedCity : '', [Validators.required]),
            postalCode: new FormControl('', [
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(5),
                Validators.pattern(/^-?(0|[1-9]\d*)?$/),
            ]),
            province: new FormControl(this.selectedProvince ? this.selectedProvince.name : '', [Validators.required]),
        });

        this.formGroup.get('city')?.disable();
        this.formGroup.get('streetAdditionalInfo')?.disable();//-DELETE-Prueba input desabilitado
    }

    setValuesForm(value?: any) {
        if (value != undefined) {
            this.selectedStreetType = {
                code: value.streetType.code ? value.streetType.code : '',
                name: value.streetType.name ? value.streetType.name : '',
            };

            this.selectedProvince = {
                code: value.province.code ? value.province.code : '',
                name: value.province.name ? value.province.name : '',
            };
            //TODO MARIO MONTAR EL LOCAL
            this.formGroup = this.fb.group({
                streetType: new FormControl(this.selectedStreetType ? this.selectedStreetType : '', [Validators.required, Validators.nullValidator]),
                streetName: new FormControl(value.streetName ? value.streetName : '', [Validators.required]),
                streetNumber: new FormControl(value.streetNumber ? value.streetNumber : '', [
                    Validators.required,
                    Validators.minLength(1),
                    Validators.maxLength(5),
                    Validators.pattern(/^-?(0|[1-9]\d*)?$/),
                ]),
                streetAdditionalInfo: new FormControl(value.streetAdditionalInfo ? value.streetAdditionalInfo : ''),
                city: new FormControl(value.city ? value.city : '', [Validators.required]),
                postalCode: new FormControl(value.postalCode ? value.postalCode : '', [
                    Validators.required,
                    Validators.minLength(5),
                    Validators.maxLength(5),
                    Validators.pattern(/^-?(0|[1-9]\d*)?$/),
                ]),
                province: new FormControl(this.selectedProvince, [Validators.required]),
            });

        }
    }

    initDefaultValues() {
        this.getStreetTypes();
        this.getProvinces();
    }

    findStreetTypesByCode(code : string) {
        return this.streetTypes.find(street => street.code === code);
    }

    findProvinceByCode(code : string) {
        return this.provinces.find(province => province.code === code);
    }

    findProvinceByName(name : string) {
        return this.provinces.find(province => province.name === name);
    }

    searchCity(event: any) {
        const query = event.query;
        this.suggestionsCity = this.cities.filter((item: string) =>
          item.toLowerCase().includes(event.query.toLowerCase())
        );
      }
    //-------------------------//
    //----------GETS-----------//
    //-------------------------//

    getStreetTypes() {
        this.addressDataService.getStreetTypes().subscribe({
            next: (response) => {
                this.streetTypes = response;
                this.selectedStreetType = this.findStreetTypesByCode(this.selectedStreetType!.code);
            },
            error: (error) => console.log(error),
        });
    }

    getProvinces() {
        this.addressDataService.getProvinces().subscribe({
            next: (response) => {
                this.provinces = response;
                const code = this.selectedProvince!.code;
                this.selectedProvince = this.findProvinceByName(this.selectedProvince!.name.toUpperCase());
                if (this.selectedProvince == undefined)
                    this.selectedProvince = this.findProvinceByCode(code);
                this.formGroup.patchValue({
                    province: this.selectedProvince,
                });
            },
            error: (error) => console.log(error),
        });
    }

    getLocations(province: string) {
        this.addressDataService.getLocations(province).subscribe((response) => {
            this.cities = response;
            this.getPostalCodes(province);
        });
    }

    getPostalCodes(province: string) {
        this.addressDataService.getPostalCodes(province).subscribe({
            next: (response) => {
                this.postalCodes = response;
            },
            error: (error) => console.log(error),
        });
    }

    //-------------------------//
    //--------ON CHANGE-------//
    //-------------------------//

    onChangeCityInput(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        this.selectedCity = inputElement.value;
        this.formGroup.patchValue({ city: this.selectedCity });
        this.formIsValid();
    }

    onChangeProvince(event: DropdownChangeEvent) {
        this.selectedProvince = event.value;
        this.getLocations(this.selectedProvince!.name);
        // this.selectedCity = '';
        // this.formGroup.get('city')?.reset();
        // this.formGroup.get('city')?.enable();
        this.formIsValid();
    }

    onChangeStreetType(event: DropdownChangeEvent) {
        this.selectedStreetType = event.value;
        this.formIsValid();
    }

    onChangePostalCode(event: Event) {
        this.formIsValid();
    }

    onChangeStreetName(event: Event) {
        this.formIsValid();
    }

    onChangeStreetNumber(event: Event) {
        this.formIsValid();
    }

    onChangeStreetAdditionalInfo(event: Event) {
        this.formIsValid();
    }

    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.continueButtonDisabled = !this.formGroup.valid;
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'house-address');
        this.router.navigate(['/main/step/contact-data-info'], { relativeTo: this.route });
    }

    onClicButtonContinue() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'house-address');
        //this.router.navigate(['/main/co-holder'], { relativeTo: this.route });
        this.router.navigate(['/main/step/house-type'], { relativeTo: this.route });
    }

    ngOnDestroy() {}
}
